import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../hooks/use-toast";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(form);
    setLoading(false);
    if (res.ok) {
      toast({ title: "Bienvenida de nuevo" });
      navigate("/");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-16 animate-fade-in">
      <div className="w-full max-w-md bg-white rounded-[2rem] shadow-xl border border-amber/30 p-9">
        <div className="text-center mb-8">
          <img src="/images/logo.png" alt="logo" className="w-16 h-16 rounded-full mx-auto mb-4" />
          <h1 className="font-serif text-4xl text-plum">Iniciar sesión</h1>
          <p className="font-body text-ink/60 mt-2">Accede a tu comunidad</p>
        </div>

        {error && (
          <div className="bg-destructive/10 text-destructive font-body text-sm rounded-xl px-4 py-3 mb-5">
            {error}
          </div>
        )}

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="font-sans text-sm text-ink/70 mb-1.5 block">Email</label>
            <div className="relative">
              <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/40" />
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full font-body bg-cream border border-amber/40 rounded-xl pl-11 pr-4 py-3 outline-none focus:border-plum transition-colors"
                placeholder="tu@email.com"
              />
            </div>
          </div>
          <div>
            <label className="font-sans text-sm text-ink/70 mb-1.5 block">Contraseña</label>
            <div className="relative">
              <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/40" />
              <input
                type="password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full font-body bg-cream border border-amber/40 rounded-xl pl-11 pr-4 py-3 outline-none focus:border-plum transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-plum text-cream font-sans py-3.5 rounded-xl hover:bg-[#684d89] transition-colors disabled:opacity-60"
          >
            <LogIn size={18} /> {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <p className="font-body text-center text-ink/60 mt-6">
          ¿No tienes cuenta?{" "}
          <Link to="/registro" className="text-terracotta font-semibold hover:underline">
            Regístrate
          </Link>
        </p>
      </div>
    </div>
  );
}
